<template>
	<div class="abiturient-my-request-list">
		<v-btn color="primary" to="/abiturient/my-requests/new">{{ $t('Создать новую заявку') }}</v-btn>
		<br><br>

		<v-fade-transition>
			<div v-if="isLoading" class="requests-loader" aria-busy="true" aria-live="polite">
				<v-alert
					v-for="n in 3"
					:key="'skeleton-' + n"
					prominent
					dense
					border="left"
					colored-border
					color="orange darken-1"
					class="mb-4 request-skeleton-alert"
					:style="{ animationDelay: (n - 1) * 0.1 + 's' }"
				>
					<v-skeleton-loader
						type="list-item-avatar-three-line, divider, list-item-two-line, actions"
						class="request-skeleton-loader"
					></v-skeleton-loader>
				</v-alert>
				<v-progress-linear
					indeterminate
					color="primary"
					rounded
					height="3"
					class="requests-loader__bar mt-2"
				></v-progress-linear>
			</div>
		</v-fade-transition>

		<v-fade-transition>
		<div v-if="!isLoading">
		<v-alert
			v-for="(item, index) in myRequestsList"
			:key="item.id"
			prominent
			dense
			border="left"
			colored-border
			color="orange darken-1">
			<div class="row row-card-no-pd">
				<div class="col-sm-12 col-md-1">
				<h2 class="text-info">{{ rowNumber(index) }}.</h2>
				</div>				
				<div class="col-sm-6 col-md-4">
					<div class="card card-stats card-round">
						<div class="card-body ">
							<div class="row"> 
								<div class="col-12">											 
										<p class="card-category">{{ displayHeaders.full_name }}</p>
										<h5 class="card-title text-dark" style="line-height:1">{{ item.full_name }}</h5>
										<br><p class="card-category text-dark">{{ item.created_at }}</p>											 
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-md-4">
					<div class="card card-stats card-round">
						<div class="card-body ">
							<div class="row">
								<div class="col-12">
										<p class="card-category">{{ displayHeaders.payment_type_name }}</p>
										<p class="card-category text-dark">{{ item.payment_type_name }}</p>
										<p class="card-category">{{ item.region_name }}</p>
								</div>

							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-6 col-md-3">
					<div class="card card-stats card-round">
						<div class="card-body">
							<div class="row">
								<div class="col-12">
										<p class="card-category">{{ displayHeaders.education_type_name }}</p>
										<p class="card-category text-dark">{{ item.education_type_name }}</p>
										<p class="card-category">{{ displayHeaders.quota }}: <span class="text-danger">{{ item.quota }}</span></p>
										<p class="card-category orange--text text-darken-1 mt-2">{{ displayHeaders.status_name }}: {{ item.status_name }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row row-card-no-pd">
				<div class="col-sm-12 col-md-12">
					<div class="card card-stats card-round">
						<div class="card-body">
							<div class="row">
								<div class="col-sm-12 text-right">
									<v-btn depressed color="primary" :to="'/abiturient/my-requests/'+item.id">{{ $t('Посмотреть') }}</v-btn>
								</div>
							</div>
						</div>
					</div>	
				</div>
			</div>
		</v-alert>
		<v-alert
			v-if="!myRequestsList.length"
			type="info"
			outlined
			dense
			class="mt-2"
		>
			{{ $t('Нет данных') }}
		</v-alert>
		<div
			v-if="usesOrdersPagination && pagination.lastPage > 1"
			class="requests-pagination text-center mt-4"
		>
			<v-pagination
				v-model="pagination.page"
				:length="pagination.lastPage"
				:total-visible="7"
				:disabled="isLoading"
				color="primary"
				@input="onPageChange"
			></v-pagination>
		</div>
		</div>
		</v-fade-transition>
	</div>
</template>

<script>
	import { mapOrderToListItem } from '@/utils/metadata';
	import { parseOrdersPaginatedResponse } from '@/utils/college';

	export default {
		mounted() {
			this.getData();
		},
		data: () => ({
			isLoading: true,
			myRequestsHeaders: {},
			myRequestsList: [],
			pagination: {
				page: 1,
				lastPage: 1,
				perPage: 10,
				total: 0,
			},
		}),
		computed: {
			usesNewApi() {
				return this.$store.getters.usesAbiturientNewApi;
			},
			usesOrdersPagination() {
				return this.usesNewApi;
			},
			displayHeaders() {
				if (this.usesNewApi) {
					return {
						full_name: this.$t('ФИО'),
						payment_type_name: this.$t('Форма оплаты'),
						education_type_name: this.$t('Тип образования'),
						quota: this.$t('Квота приема'),
						status_name: this.$t('Статус'),
					};
				}
				return this.myRequestsHeaders;
			},
		},
		watch: {
			'$store.state.language': function () {
				this.getData();
			},
		},
		methods: {
			rowNumber(index) {
				if (this.usesOrdersPagination) {
					return (this.pagination.page - 1) * this.pagination.perPage + index + 1;
				}
				return index + 1;
			},
			onPageChange(page) {
				this.pagination.page = page;
				this.getData();
			},
			async getData() {
				this.isLoading = true;
				try {
					const isNewApi = this.$store.getters.usesAbiturientNewApi;

					if (isNewApi) {
						const [ordersResponse, metadataResponse] = await Promise.all([
							this.$http.get('/orders', {
								params: {
									page: this.pagination.page,
									count: this.pagination.perPage,
								},
							}),
							this.$http.get('/metadata'),
						]);
						const metadata = metadataResponse.data.data || metadataResponse.data;
						const parsed = parseOrdersPaginatedResponse(ordersResponse.data);

						this.pagination.page = parsed.currentPage;
						this.pagination.lastPage = parsed.lastPage;
						this.pagination.perPage = parsed.perPage;
						this.pagination.total = parsed.total;
						this.myRequestsList = parsed.items.map((order) => (
							mapOrderToListItem(order, metadata, this.$t.bind(this))
						));
						return;
					}

					this.pagination.page = 1;
					this.pagination.lastPage = 1;
					this.pagination.perPage = 10;
					this.pagination.total = 0;

					const response = await this.$http.get('/request');
					response.data.data.requestList.headers.forEach((item) => {
						this.myRequestsHeaders[item.value] = item.text;
					});
					this.myRequestsList = response.data.data.requestList.list;
				} finally {
					this.isLoading = false;
				}
			},
		},
	};
</script>

<style scoped src="@/assets/css/abiturient/MyRequestListView.css"></style>